import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HowHenterPantWorksComponent } from './how-henter-pant-works.component';
import { HowHenterPantWorksRoutingModule } from './how-henter-pant-works-routing.module';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    HowHenterPantWorksComponent
  ],
  imports: [
    CommonModule,
    HowHenterPantWorksRoutingModule,
    SharedModule,
    TranslatePipe
  ]
})
export class HowHenterPantWorksModule {}

